/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react';
import { Tooltip } from '@jutro/components';
import { useTranslator } from '@jutro/locale';
import { MetadataContent } from '@jutro/legacy/uiconfig';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
// eslint-disable-next-line import/no-unresolved
import appConfig from 'app-config';
import { withAuthenticationContext } from '@xengage/gw-digital-auth-react';
import { MLPortalSettingsService } from 'gw-capability-quoteandbind';
import { UserService, GoogleCCaaSService_Ext } from 'gw-capability-gateway';
import { MLClickToChatService } from 'ml-services-common-react'
import { AskServiceOpsService, withMLModalService } from 'ml-portals-services-react';
import classNames from 'classnames';
import { ChatBotUtil } from 'ml-portals-util-js';
import { error } from '@jutro/logger';
import { platformMessages } from 'ml-components-platform-react';
import MLSearchBarComponent from '../MLSearchBarComponent/MLSearchBarComponent';


import metadata from './PageHeaderComponent.metadata.json5';

import pageHeaderStyles from './PageHeaderComponent.module.scss';
import messages from './PageHeaderComponent.messages';

import { Link } from '@jutro/router';

class PageHeaderComponent extends Component {
    static propTypes = {
        authHeader: PropTypes.shape({}),
        history: PropTypes.shape({
            push: PropTypes.func,
            location: PropTypes.shape({
                pathname: PropTypes.string
            })
        }).isRequired,
        logout: PropTypes.func,
        user_name: PropTypes.string,
        authUserData: PropTypes.shape({
            displayName: PropTypes.string,
            userType: PropTypes.string,
            primaryProducerCode_ML: PropTypes.shape({
                producerType_ML: PropTypes.string
            })
        })
    };

    static defaultProps = {
        authUserData: {
            displayName: '',
            userType: ''
        }
    };

    state = {
        searchText: '',
        isLogout: false,
        showError: false,
        showStartNewButton: false,
        canCreateAccount: false,
        vueSystemLink: '',
        showAskServiceOpsButton: false,
        generativeIAURL: '',
        enableAgentKnowledgeHub: false
    };

    componentDidMount = () => {
        this.updateGenIAURL();
        const hasServicesCallError = window.localStorage.getItem('hasServicesCallError');
        if (hasServicesCallError === 'true') {
            return ;
        }
        this.getShowStartNewQuoteButton();
        this.showNewQuoteButton();
        this.getVueSystemLink();
        this.initChat();

    };

    initChat = async () => {
        const { authHeader } = this.props;

        if (!window.IS_CHAT_LOADED) {
            const producercodeDetails = await UserService.getPrimaryProducerCodeAndGroup(authHeader);
            
            console.log("ProducerCodeDetails", producercodeDetails?.primaryProducerCode_ML);

            if (producercodeDetails && producercodeDetails?.primaryProducerCode_ML) {
                this.loadChatBot(producercodeDetails?.primaryProducerCode_ML);
            }
        }
    }

    updateGenIAURL = async () => {
        const { authHeader } = this.props;
        const portalSettings = await MLPortalSettingsService.getSettings(authHeader);
        const { generativeIAURL, enableAgentKnowledgeHub} = portalSettings;
        this.setState((prevState) => ({...prevState, generativeIAURL, enableAgentKnowledgeHub: Boolean(enableAgentKnowledgeHub)}))
    }

    getChatToken = async (identifier) => {
        const { authHeader } = this.props;
        
        const EISToken = await GoogleCCaaSService_Ext.getChatToken(identifier, authHeader);

        return EISToken;
    }



    loadChatBot = async (primaryProducer) => {

        const { authHeader, authUserData } = this.props;
        const { MLUserTypes } = appConfig;
        const portalSettings = await MLPortalSettingsService.getSettings(authHeader);
        const { enableGoogleChatBot_Ext, googleChatBotProxyURL_Ext, googleChatBotFrmsRegion} = portalSettings;

        this.setState((prevState) => ({...prevState}))

        console.log("UserType" ,authUserData.userType)

        try {
            if (enableGoogleChatBot_Ext && authUserData.userType === MLUserTypes.IA) {
                const proxyURL = googleChatBotProxyURL_Ext;
                const jwtToken = await GoogleCCaaSService_Ext.getGoogleCCaaSAccessToken(
                    {
                        "producerCode": primaryProducer?.code,
                        "agentFirstName": authUserData?.firstName,
                        "agentLastName": authUserData?.lastName,
                        "producerType": authUserData?.userTypeName_ML,
                        "agentAgencyName": primaryProducer?.organization_ML?.name,
                        "stateCode": primaryProducer?.organization_ML?.address?.state,
                        "pageName": "Quote",
                        "brandName": "FWS A360",
                        "contactType": "Agent"
                    }, authHeader);

                ChatBotUtil.initChatWizard({ proxyURL, jwtToken , frmsRegion:googleChatBotFrmsRegion, getChatToken :this.getChatToken});

                window.IS_CHAT_LOADED = true
                console.log("ChatLoaded" ,"GoogleCcasS")
                console.log("IS_CHAT_LOADED", window.IS_CHAT_LOADED);
            } else {
                this.loadClickToChat();
            }
        }
        catch {
            error('Error loading Chat Bot');

        }

    }


    getShowStartNewQuoteButton = async () => {
        const { authHeader } = this.props;
        const permissionDTO = {
            permission: 'createsubmission'
        };
        const showStartNewButton = await UserService.hasUserSystemPermission(
            permissionDTO,
            authHeader
        );
        this.setState({ showStartNewButton });
    };

    showNewQuoteButton = async () => {
        const { authHeader } = this.props;
        const accountPermCheckDTO = {
            permEntityType: 'Account',
            permEntityID: null,
            permission: 'create',
            isCheckPermEntity: false
        };

        const canCreateAccount = await UserService.hasUserPermission(
            accountPermCheckDTO,
            authHeader
        );
        this.setState({ canCreateAccount });
    };

    getVueSystemLink = async () => {
        const { authHeader } = this.props;
        const vueSystemLink = await UserService.getVueSystemLink(
            authHeader
        );
        this.setState({ vueSystemLink });
    };

    writeValue = (value) => {
        this.setState({ searchText: value });
    };

    goToFaq = () => {
        const { history } = this.props;
        history.push('/faq');
    };

    goToPreference = () => {
        const { history } = this.props;
        history.push('/preferences');
    };

    goToLogout = () => {
        const { isLogout } = this.state;
        const { logout } = this.props;
        if (!isLogout) {
            logout();
            this.setState({
                isLogout: true
            });
        }
    };

    goToNewQuote = () => {
        const { history } = this.props;
        const fromLocation = history.location.pathname;
        const { lobQuoteURL } = appConfig;
        const lobPaths = Object.values(lobQuoteURL) || [];
        const fromLOB = lobPaths.filter((value) => fromLocation.indexOf(value) !== -1);

        const previousLocation = {
            prevLocation: !!fromLOB.length
        };

        return history.push('/new-quote-account-search', previousLocation);
    };

    goToQuoteThisAccount = () => {
        const { history } = this.props;
        const {
            history: {
                location: { pathname }
            }
        } = this.props;
        const accountNumber = pathname.match('accounts/(.*)/(.*)');
        return history.push(`/new-quote/${accountNumber[1]}`);
    };

    loadClickToChat = () => {
        const { authHeader } = this.props;
        const { authUserData } = this.props;
        const { MLUserTypes } = appConfig;

        const settings = MLPortalSettingsService.getSettings(authHeader);

        settings.then((response) => {            
            // Show Help/Chat button if script parameter is true and agent type is EA
            if (response && response.salesForceAskServiceOpsEnabled && (authUserData.userType === MLUserTypes.PCS)) {
                this.setState({ showAskServiceOpsButton: true });
                window.IS_CHAT_LOADED = true
                console.log("ChatLoaded" ,"EA-Help/Chat")
                console.log("IS_CHAT_LOADED", window.IS_CHAT_LOADED)
            } 
            // Otheriwse continue to show ClickToChat button
            else if (response && response.salesForceClickToChatEnabled &&
                    response.clickToChatSettings.gpaChatSettings.enabled) {
                MLClickToChatService.init("GPA", () => {
                    MLClickToChatService.setChatData(
                        {
                            'FirstName': authUserData.firstName,
                            'LastName':  authUserData.lastName,
                            'Contact_Name__c':  authUserData.displayName,
                            'Brand__c': 'Farmers Workplace Solutions',
                            'Contact_Type__c': 'Agent',
                            'FWS_Customer_Type__c': 'Agent',
                            'FWS_Agent_Type__c': MLClickToChatService.getAgentType(authUserData.userTypeName_ML),
                            'FWS_Producer_type__c':authUserData.userTypeName_ML
                        }, 'GPA');
                }, authHeader);
            }
        });
    };

    goToAskServiceOpsPreChat = () => {
        const askSoService = AskServiceOpsService();
        const { history } = this.props;
        window.open(askSoService.getPreChatLink(history) , '_blank');
    };

    goToHome = () => {
        const { history } = this.props;
        return history.push('/');
    }

    goToGenerativeIA = () => {
        const {generativeIAURL} = this.state
        if(!_.isEmpty(generativeIAURL)){
            window.open(generativeIAURL, "_blank", "noopener,noreferrer")
        }
    }

    authSelectionTooltipTemplate = (translator, vueSystemLink) => {
        const {
            MLUserTypes,
            MLProducerTypes
        } = appConfig;

        const {
            authUserData
        } = this.props;

        const isPCS = () => {
            return authUserData.userType === MLUserTypes.PCS;
        };

        const isIA = () => {
            return authUserData.userType === MLUserTypes.IA;
        };

        const isMetGA = () => {
            return (authUserData.userType === MLUserTypes.PCS
                && authUserData.primaryProducerCode_ML.producerType_ML === MLProducerTypes.IA)
                || authUserData.userType === MLUserTypes.MET_GA;
        };

        return (
            <div className="ml-tooltip-template">
                <ul className="styled-ul-list-border-bottom">
                    <li>
                        <Link onClick={() => this.goToPreference()}>
                            {translator(messages.preferencesLink)}
                        </Link>
                    </li>
                    {vueSystemLink && (isPCS() || isIA() || isMetGA())
                    && (
                        <li>
                            <Link title="Opens in a new tab/window" href={vueSystemLink} target="_blank">
                                {translator(messages.vueLink)}
                            </Link>
                        </li>
                    )}
                    <li>
                        <Link onClick={() => this.goToLogout()}>
                            {translator(messages.logOut)}
                        </Link>
                    </li>
                </ul>
            </div>
        );
    };

    AuthStatusTooltip = () => {
        const translator = useTranslator();
        const { vueSystemLink } = this.state;
        const { authUserData } = this.props;

        return (
            <Tooltip
                id="tooltip"
                placement="bottom"
                trigger="click"
                content={this.authSelectionTooltipTemplate(translator, vueSystemLink)}
            >
                <Link className={classNames(pageHeaderStyles.userName)} role="button" aria-haspopup={true}>
                {authUserData.displayName}
                <span className={classNames(pageHeaderStyles.dropdownControl, 'icon-ml-carrot-down-outline')} />
                </Link>
            </Tooltip>
        );
    };

    render() {
        const {
            MLUserTypes
        } = appConfig;

        const {
            searchText, showError, canCreateAccount, showStartNewButton, showAskServiceOpsButton
        } = this.state;
        const {
            history,
            user_name: userName,
            authUserData
        } = this.props;

        const isHomeScreen = history.location.pathname === '/';
        const isNewQuoteScreen = history.location.pathname.startsWith('/new-quote');

        const resolvers = {
            resolveClassNameMap: pageHeaderStyles,
            resolveCallbackMap: {
                goToFaq: this.goToFaq,
                goToPreference: this.goToPreference,
                goToLogout: this.goToLogout,
                goToNewQuote: this.goToNewQuote,
                goToQuoteThisAccount: this.goToQuoteThisAccount,
                goToAskServiceOpsPreChat: this.goToAskServiceOpsPreChat,
                goToHome: this.goToHome,
                goToGenerativeIA: this.goToGenerativeIA
            },
            resolveComponentMap: {
                authStatusTooltip: this.AuthStatusTooltip,
                MLSearchBarComponent: MLSearchBarComponent
            },
        };
        const overrideProps = {
            appLogoPortrait: {
                tabIndex: "0",
            },
            logo: {
                tabIndex: "0",
            },
            headerSearchBox: {
                history, 
                authUserData
            },
            logo: {
                role: 'img',
                "tabindex": 0
            },
            homeItem: {
                visible: false
            },
            homeBtn: {
                className: classNames('icon-home-nav icon', { active: isHomeScreen }),
                textClassName: classNames('link', { active: isHomeScreen })
            },
            startNewQuoteBtn: {
                visible: canCreateAccount && showStartNewButton,
                className: classNames('icon-ml-circle-plus icon', { active: isNewQuoteScreen }),
                textClassName: classNames('link', { active: isNewQuoteScreen })
            },
            agentKnowledgeBtn: {
                visible: this.state.enableAgentKnowledgeHub && authUserData.userType !== MLUserTypes.PCS,
                className: classNames('icon-ml-help-icon icon', { active: isNewQuoteScreen }),
                textClassName: classNames('link capitalizeText', { active: isNewQuoteScreen })
            },
            userName: {
                content: authUserData.displayName
            },
            askServiceOpsBtn: {
                visible: showAskServiceOpsButton
            },
            gwHeaderMenu: {
                role: 'navigation'
            },
            headerSearch: {
                role: 'search',
                className: classNames('headerSearchBar', { paddingRight10: !this.state.enableAgentKnowledgeHub })
            },
            agentKnowledgeItem:{
                visible: true
            }
        };
        return (
            <MetadataContent
                uiProps={metadata.componentContent}
                overrideProps={overrideProps}
                {...resolvers} />
        );
    }
}

export default withMLModalService(withRouter(withAuthenticationContext(PageHeaderComponent)));
